import * as ObjectTypes from 'customer-data-objects/constants/ObjectTypes';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message
import * as DSAssetFamilies from '../../filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { DSAssetFamilyToObjectSegType, ObjectSegTypeToDSAssetFamily
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message
} from '../../filterQueryFormat/DSAssetFamilies/DSAssetFamilyMappings';
import { HUBSPOT_DEFINED

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message
} from '../../filterQueryFormat/associations/AssociationCategory';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module './co... Remove this comment to see the full error message
import { IN_LIST_TYPE } from './constants/constants';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message
import { RESTRICTED_FILTER_VALUE } from '../../permissions/fieldLevelPermissions';
import { Map as ImmutableMap } from 'immutable';
import { filterFamilySupportsDynamic, getDynamicFilterFamilyBasis, makeDynamicFilterFamily, testDynamicFilterFamily
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
} from 'customer-data-filters/filterQueryFormat/DynamicFilterFamilies';
import { fromObjectSegFilterStrict } from './fromObjectSegFilter';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message
import { getAssociationTypeIdByObjectTypeId } from '../../filterQueryFormat/associations/AssociationTypeId';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module './Ob... Remove this comment to see the full error message
import { getDSAssetFamilyForType } from './ObjectSegTypeToDSAssetFamily';
import { getObjectTypeIdSupportedFamily, isCustomBehavioralEventObjectTypeId, isUnifiedEventObjectTypeId
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message
} from '../../filterQueryFormat/ObjectTypeId';
import { isObjectSegPseudoContactProperty, isObjectSegPseudoProperty
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module './Ob... Remove this comment to see the full error message
} from './ObjectSegPseudoProperties';
import { isOperator } from '../../filterQueryFormat/operator/Operator';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module './fr... Remove this comment to see the full error message
import { isWorkflowInListType } from './fromObjectSegFilter/fromListMembershipFilter';
import { toObjectSegFilterStrict } from './toObjectSegFilter';
import And from '../../filterQueryFormat/logic/And';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message
import Restricted from '../../filterQueryFormat/logic/Restricted';
import Or from '../../filterQueryFormat/logic/Or';
import always from 'transmute/always';
import filterNot from 'transmute/filterNot';
import getIn from 'transmute/getIn';
import partial from 'transmute/partial';
import update from 'transmute/update';
import { isLogicGroup } from '../../filterQueryFormat/logic/LogicGroup';
import { isILSFilterBranch } from '../../types/objectSeg/ilsFilter';
import invariant from 'react-utils/invariant';
import { resolveIsUngated } from '../../utilities/UserInfoHelper';
const createBranch = (branchOperator, objectType, parentObjectType, getAssociationTypeId) => {
  const associationTypeId = getAssociationTypeId(parentObjectType, objectType);
  const associationBranchAttributes = {
    associationCategory: HUBSPOT_DEFINED,
    associationTypeId,
    filterBranchType: 'ASSOCIATION',
    objectType,
    operator: 'IN_LIST'
  };
  return Object.assign({
    filterBranches: [],
    filterBranchOperator: branchOperator,
    filterBranchType: branchOperator,
    filters: []
  }, associationTypeId ? associationBranchAttributes : {});
};
const createBranchWithCustomObjects = (branchOperator, objectType, parentObjectType, getAssociationTypeId, getAssociationCategory, logicGroup) => {
  const objectTypeId = getObjectTypeIdSupportedFamily(objectType);
  const parentObjectTypeId = getObjectTypeIdSupportedFamily(parentObjectType);
  const associationTypeId = getAssociationTypeId(parentObjectTypeId, objectTypeId, logicGroup);
  const associationCategory = getAssociationCategory(parentObjectTypeId, objectTypeId, logicGroup);
  const associationBranchAttributes = {
    objectTypeId,
    operator: 'IN_LIST'
  };
  if (objectTypeId === DSAssetFamilies.PRODUCT_PROPERTY && parentObjectTypeId === DSAssetFamilies.LINE_ITEM_PROPERTY) {
    associationBranchAttributes.filterBranchType = 'PROPERTY_ASSOCIATION';
    associationBranchAttributes.propertyWithObjectId = 'hs_product_id';
  } else if (associationTypeId) {
    associationBranchAttributes.filterBranchType = 'ASSOCIATION';
    associationBranchAttributes.associationCategory = associationCategory;
    associationBranchAttributes.associationTypeId = associationTypeId;
  } else if (isUnifiedEventObjectTypeId(objectTypeId) || isCustomBehavioralEventObjectTypeId(objectTypeId)) {
    delete associationBranchAttributes.objectTypeId;
    // @ts-expect-error ts-migrate(2790) FIXME: The operand of a 'delete' operator must be optiona... Remove this comment to see the full error message
    delete associationBranchAttributes.operator;
    associationBranchAttributes.eventTypeId = objectTypeId;
    associationBranchAttributes.filterBranchType = 'UNIFIED_EVENTS';
  }
  const branch = Object.assign({
    filterBranches: [],
    filterBranchOperator: branchOperator,
    filterBranchType: branchOperator,
    filters: []
  }, associationBranchAttributes.filterBranchType ? associationBranchAttributes : {});
  if (logicGroup.includeObjectsWithNoAssociatedObjects) {
    branch.coalescingRefineBy = {
      type: 'SetOccurrencesRefineBy',
      setType: 'ANY_INCLUDE_EMPTY'
    };
  }
  return branch;
};
const addFilter = (branch, filter) =>
// @ts-expect-error ts-migrate(2488) FIXME: Type 'unknown' must have a '[Symbol.iterator]()' m... Remove this comment to see the full error message
update('filters', filters => [...filters, filter], branch);
const addFilterBranch = (branch, branchToAdd) => update('filterBranches',
// @ts-expect-error ts-migrate(2488) FIXME: Type 'unknown' must have a '[Symbol.iterator]()' m... Remove this comment to see the full error message
filterBranches => [...filterBranches, branchToAdd], branch);
const addIntegrationFilterLine = (existingFilter, filterToAdd) => {
  const newFilter = Object.assign({}, existingFilter, {
    filterLines: [...existingFilter.filterLines, ...filterToAdd.filterLines]
  });
  return newFilter;
};
export const isPseudo = (baseFilterFamily, filterFamily) => {
  return baseFilterFamily === DSAssetFamilies.CONTACT_PROPERTY && isObjectSegPseudoContactProperty(filterFamily) || isObjectSegPseudoProperty(filterFamily);
};
const createIntegrationFilter = (filterFamily, condition, isUngated) => {
  let filter;
  condition.conditions.forEach(subCondition => {
    const subConditionFilter = toObjectSegFilterStrict(subCondition, filterFamily, isUngated);
    if (!filter) {
      filter = subConditionFilter;
    } else {
      filter = addIntegrationFilterLine(filter, subConditionFilter);
    }
  });
  return filter;
};

/**
 * Converts condition to filter or branch and adds it to branch
 *
 * @param {string} objectTypeOrId can be an ObjectTypeId or an objectType
 * @param {ObjectSegFilterBranch} branch
 * @param {LogicGroup | Operator} condition
 */
const addConditionToBranch = (objectTypeOrId, isUngated, options, branch, condition) => {
  const assetFamily = getDSAssetFamilyForType(objectTypeOrId) || objectTypeOrId;
  if (isOperator(condition)) {
    const filter = toObjectSegFilterStrict(condition, assetFamily, isUngated);
    return addFilter(branch, filter);
  }
  const assetFamilyOfCondition = getDSAssetFamilyForType(condition.filterFamily) || condition.filterFamily;
  const filterFamilyBasisOfCondition = getDynamicFilterFamilyBasis(assetFamilyOfCondition) || assetFamilyOfCondition;
  if (isLogicGroup(condition) && filterFamilyBasisOfCondition === DSAssetFamilies.INTEGRATION) {
    branch = addFilter(branch, createIntegrationFilter(assetFamilyOfCondition, condition, isUngated));
    return branch;
  }
  if (isPseudo(assetFamily, filterFamilyBasisOfCondition)) {
    condition.conditions.forEach(subCondition => {
      const filter = toObjectSegFilterStrict(subCondition, assetFamilyOfCondition, isUngated);
      branch = addFilter(branch, filter);
    });
    return branch;
  }

  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const newBranch = logicGroupToObjectSeg(condition, isUngated, options, objectTypeOrId);
  return addFilterBranch(branch, newBranch);
};
const _filterBranchOperatorNameByLogicGroup = ImmutableMap([[And, 'AND'], [Or, 'OR']]);
const getFilterBranchOperator = logicGroupRecord => _filterBranchOperatorNameByLogicGroup.get(logicGroupRecord.constructor);
const isContactToLineItemFilterBranch = (parentObjectSegType, objectSegType) => {
  return parentObjectSegType === ObjectTypes.CONTACT && objectSegType === ObjectTypes.LINE_ITEM || parentObjectSegType === DSAssetFamilies.CONTACT_PROPERTY && objectSegType === DSAssetFamilies.LINE_ITEM_PROPERTY;
};
const isContactToProductFilterBranch = (parentObjectSegType, objectSegType) => {
  return parentObjectSegType === ObjectTypes.CONTACT && objectSegType === ObjectTypes.PRODUCT || parentObjectSegType === DSAssetFamilies.CONTACT_PROPERTY && objectSegType === DSAssetFamilies.PRODUCT_PROPERTY;
};

/**
 * Adds Deal into the Contact to Line Item filter tree
 *
 * Line Items aren't directly associated to the Contacts.
 * Contacts have associated Deals and Deals have associated Line Items
 * therefore Deal association branch needs to be injected
 */
const buildContactToLineItemLogicGroup = logicGroup => {
  const extendedLogicGroup = And.of(And.of(...logicGroup.conditions.values()).merge({
    filterFamily: DSAssetFamilies.LINE_ITEM_PROPERTY,
    includeObjectsWithNoAssociatedObjects: logicGroup.includeObjectsWithNoAssociatedObjects
  })).merge({
    filterFamily: DSAssetFamilies.DEAL_PROPERTY,
    includeObjectsWithNoAssociatedObjects: logicGroup.includeObjectsWithNoAssociatedObjects
  });
  return extendedLogicGroup;
};
const buildContactToProductLogicGroup = logicGroup => {
  /**
   * Adds Deal into the Contact to Product filter tree
   *
   * Products aren't directly associated to the Contacts.
   * Contacts have associated Deals therefore Deal association branch need to be injected
   */
  return And.of(And.of(...logicGroup.conditions.values()).merge({
    filterFamily: DSAssetFamilies.PRODUCT_PROPERTY,
    includeObjectsWithNoAssociatedObjects: logicGroup.includeObjectsWithNoAssociatedObjects
  })).merge({
    filterFamily: DSAssetFamilies.DEAL_PROPERTY,
    includeObjectsWithNoAssociatedObjects: logicGroup.includeObjectsWithNoAssociatedObjects
  });
};
const logicGroupToObjectSeg = (logicGroup, isUngated, options, parentFilterFamily) => {
  // HACK: useDSFilterFamilies allows ObjectSeg to work in DSFilterEditor, this
  // can be removed once all ObjectSeg users are on DSFilterEditor see: https://git.hubteam.com/HubSpot/customer-data-filters/pull/406
  const useDSFilterFamilies = options.useDSFilterFamilies === true;
  const enableCustomObjectSupport = options.enableCustomObjectSupport === true;
  const getAssociationTypeId = options.getAssociationTypeId || getAssociationTypeIdByObjectTypeId;
  const getAssociationCategory = options.getAssociationCategory || always(HUBSPOT_DEFINED);
  const filterFamily = logicGroup.filterFamily;
  let conditions = logicGroup.conditions;
  const parentObjectSegType = useDSFilterFamilies ? DSAssetFamilyToObjectSegType.get(parentFilterFamily) || parentFilterFamily : parentFilterFamily;
  let objectSegType = useDSFilterFamilies ? DSAssetFamilyToObjectSegType.get(filterFamily) || filterFamily : filterFamily;
  const branchOperator = getFilterBranchOperator(logicGroup);
  let branch;
  if (enableCustomObjectSupport) {
    if (isContactToProductFilterBranch(parentObjectSegType, objectSegType)) {
      // if current logic group is an association branch between contact and
      // product inject deals and line item association branches between them and shift
      // serialization two steps back from product to deal
      // (see https://hubspot.slack.com/archives/CUNEM77AM/p1631197062035300)
      const contactToProductLogicGroup = buildContactToProductLogicGroup(logicGroup);
      branch = createBranchWithCustomObjects('AND', ObjectTypes.DEAL, ObjectTypes.CONTACT, getAssociationTypeId, getAssociationCategory, contactToProductLogicGroup);
      conditions = contactToProductLogicGroup.getIn(['conditions']);
      objectSegType = ObjectTypes.DEAL;
    } else if (isContactToLineItemFilterBranch(parentObjectSegType, objectSegType)) {
      // if current logic group is an association branch between contact and
      // line item inject deals association branch between them and shift
      // serialization one step back from line item to deal
      // (see https://git.hubteam.com/HubSpot/crm-filters/issues/208)
      const contactToLineItemLogicGroup = buildContactToLineItemLogicGroup(logicGroup);
      branch = createBranchWithCustomObjects('AND', ObjectTypes.DEAL, ObjectTypes.CONTACT, getAssociationTypeId, getAssociationCategory, contactToLineItemLogicGroup);
      conditions = contactToLineItemLogicGroup.conditions;
      objectSegType = ObjectTypes.DEAL;
    } else {
      branch = createBranchWithCustomObjects(branchOperator, objectSegType, parentObjectSegType, getAssociationTypeId, getAssociationCategory, logicGroup);
    }
  } else {
    branch = createBranch(branchOperator, objectSegType, parentObjectSegType, getAssociationTypeId);
  }
  return conditions.reduce(partial(addConditionToBranch, objectSegType, isUngated, options), branch);
};
export const toObjectSeg_XO = (logicGroup, isUngated, options = {}) => {
  invariant(isLogicGroup(logicGroup), `Expected ${logicGroup} to be a logic group`);
  const validIsUngated = resolveIsUngated(isUngated);
  return logicGroupToObjectSeg(logicGroup, validIsUngated, options);
};
const requiresGrouping = filter => isObjectSegPseudoContactProperty(getDSAssetFamilyForType(filter.filterType) || filter.filterType) || isObjectSegPseudoProperty(getDSAssetFamilyForType(filter.filterType) || filter.filterType);
const getOperatorsFromFilter = (filterFamily, filter, getOperatorFromFilter) => {
  if (testDynamicFilterFamily(DSAssetFamilies.INTEGRATION, filterFamily)) {
    const filters = filter.filterLines.map(subFilter => {
      const curFilter = Object.assign({}, filter, {
        filterLines: [subFilter]
      });
      return getOperatorFromFilter(curFilter);
    });
    return filters;
  }
  return [getOperatorFromFilter(filter)];
};
const getGroupedOperatorsFromObjSeg = (filters, getOperatorFromFilter, baseObjectTypeId) => {
  const assetFamilies = {};
  filters.forEach((filter, index) => {
    let assetFamily = getDSAssetFamilyForType(filter.filterType);

    // the DSAssetFamily for IN_LIST aliases import and workflows and has to be overridden
    if (assetFamily === DSAssetFamilies.IN_LIST) {
      const inListType = getIn(['metadata', 'inListType'], filter);
      if (inListType === IN_LIST_TYPE.IMPORT) {
        assetFamily = DSAssetFamilies.IMPORT;
      } else if (isWorkflowInListType(inListType)) {
        assetFamily = DSAssetFamilies.WORKFLOW;
      }
    }
    if (assetFamily === DSAssetFamilies.INTEGRATION) {
      assetFamily = makeDynamicFilterFamily(DSAssetFamilies.INTEGRATION, filter.eventTypeId);
    } else if (filterFamilySupportsDynamic(assetFamily)) {
      assetFamily = makeDynamicFilterFamily(assetFamily, baseObjectTypeId);
    }
    const key = testDynamicFilterFamily(DSAssetFamilies.INTEGRATION, assetFamily) ? `${assetFamily}__${index}` : assetFamily;

    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    assetFamilies[key] = assetFamilies[key] || {
      assetFamily,
      operators: []
    };
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    assetFamilies[key].operators.push(...getOperatorsFromFilter(assetFamily, filter, getOperatorFromFilter));
  });
  return Object.values(assetFamilies).map(entry => And.of(...entry.operators).set('filterFamily', entry.assetFamily));
};
const getIncludeObjectsWithNoAssociatedObjects = filterBranch => {
  const {
    coalescingRefineBy
  } = filterBranch;
  if (coalescingRefineBy) {
    return coalescingRefineBy.setType === 'ANY_INCLUDE_EMPTY' && coalescingRefineBy.type === 'SetOccurrencesRefineBy';
  }
  return false;
};
const getIsContactToLineItemObjectSegFilterBranch = (baseFilterFamily, filterBranch) => {
  const maybeLineItemTypeId = getIn(['filterBranches', '0', 'objectTypeId'], filterBranch);
  return baseFilterFamily === DSAssetFamilies.CONTACT_PROPERTY && maybeLineItemTypeId === DSAssetFamilies.LINE_ITEM_PROPERTY;
};
const getIsContactToProductObjectSegFilterBranch = (baseFilterFamily, filterBranch) => {
  var _filterBranch$filterB, _filterBranch$filterB2;
  const maybeProductTypeIdIfHasPropertyAssociation = (_filterBranch$filterB = filterBranch.filterBranches) === null || _filterBranch$filterB === void 0 || (_filterBranch$filterB = _filterBranch$filterB[0]) === null || _filterBranch$filterB === void 0 || (_filterBranch$filterB = _filterBranch$filterB.filterBranches) === null || _filterBranch$filterB === void 0 || (_filterBranch$filterB = _filterBranch$filterB[0]) === null || _filterBranch$filterB === void 0 ? void 0 : _filterBranch$filterB.objectTypeId;
  const maybeProductTypeIdIfRemovedPropertyAssociation = (_filterBranch$filterB2 = filterBranch.filterBranches) === null || _filterBranch$filterB2 === void 0 || (_filterBranch$filterB2 = _filterBranch$filterB2[0]) === null || _filterBranch$filterB2 === void 0 ? void 0 : _filterBranch$filterB2.objectTypeId;
  const hasProductFilterBranch = maybeProductTypeIdIfHasPropertyAssociation === DSAssetFamilies.PRODUCT_PROPERTY || maybeProductTypeIdIfRemovedPropertyAssociation === DSAssetFamilies.PRODUCT_PROPERTY;
  return baseFilterFamily === DSAssetFamilies.CONTACT_PROPERTY && filterBranch.objectTypeId === DSAssetFamilies.DEAL_PROPERTY && hasProductFilterBranch;
};
const fromObjectSegWithCustomObjects = (filterBranch, getField, baseFilterFamily, isUngated) => {
  const baseObjectTypeId = getObjectTypeIdSupportedFamily(baseFilterFamily);
  const isContactToProductObjectSegFilterBranch = getIsContactToProductObjectSegFilterBranch(baseFilterFamily, filterBranch);
  const isContactToLineItemObjectSegFilterBranch = getIsContactToLineItemObjectSegFilterBranch(baseFilterFamily, filterBranch);
  let filterBranches = filterBranch.filterBranches;
  let filters = filterBranch.filters;
  const {
    filterBranchOperator,
    objectType,
    objectTypeId,
    eventTypeId
  } = filterBranch;
  let parsedObjectTypeId = baseObjectTypeId;
  if (isContactToProductObjectSegFilterBranch) {
    var _filterBranch$filterB3, _filterBranch$filterB4, _filterBranch$filterB5;
    filterBranches = [];
    const hasPropertyAssociation = ((_filterBranch$filterB3 = filterBranch.filterBranches) === null || _filterBranch$filterB3 === void 0 || (_filterBranch$filterB3 = _filterBranch$filterB3[0]) === null || _filterBranch$filterB3 === void 0 || (_filterBranch$filterB3 = _filterBranch$filterB3.filterBranches) === null || _filterBranch$filterB3 === void 0 || (_filterBranch$filterB3 = _filterBranch$filterB3[0]) === null || _filterBranch$filterB3 === void 0 ? void 0 : _filterBranch$filterB3.filterBranchType) === 'PROPERTY_ASSOCIATION';
    filters = hasPropertyAssociation ? // if current filter branch is Contact -> Deal -> Line Item -> Product
    // association remove Deal and Line Item from the chain and present branch
    // as direct relationship Contact -> Product
    (_filterBranch$filterB4 = filterBranch.filterBranches) === null || _filterBranch$filterB4 === void 0 || (_filterBranch$filterB4 = _filterBranch$filterB4[0]) === null || _filterBranch$filterB4 === void 0 || (_filterBranch$filterB4 = _filterBranch$filterB4.filterBranches) === null || _filterBranch$filterB4 === void 0 || (_filterBranch$filterB4 = _filterBranch$filterB4[0]) === null || _filterBranch$filterB4 === void 0 ? void 0 : _filterBranch$filterB4.filters : // if current filter branch is Contact -> Deal -> Product
    // association remove Deal from the chain and present branch
    // as direct relationship Contact -> Product
    (_filterBranch$filterB5 = filterBranch.filterBranches) === null || _filterBranch$filterB5 === void 0 || (_filterBranch$filterB5 = _filterBranch$filterB5[0]) === null || _filterBranch$filterB5 === void 0 ? void 0 : _filterBranch$filterB5.filters;
    parsedObjectTypeId = DSAssetFamilies.PRODUCT_PROPERTY;
  } else if (isContactToLineItemObjectSegFilterBranch) {
    // if current filter branch is Contact -> Deal -> Line Item
    // association remove Deal from the chain and present branch
    // as direct relationship Contact -> Line Item
    filterBranches = [];
    filters = getIn(['filterBranches', '0', 'filters'], filterBranch);
    parsedObjectTypeId = DSAssetFamilies.LINE_ITEM_PROPERTY;
  } else if (objectTypeId) {
    parsedObjectTypeId = objectTypeId;
  } else if (objectType) {
    parsedObjectTypeId = getObjectTypeIdSupportedFamily(objectType);
  } else if (eventTypeId) {
    parsedObjectTypeId = eventTypeId;
  }
  const getOperatorFromFilter = filter => fromObjectSegFilterStrict(filter, getField, parsedObjectTypeId, isUngated);

  // @ts-expect-error transmute works with native data structures
  const filtersToConvert = filterNot(requiresGrouping, filters);
  const operators = filtersToConvert.map(getOperatorFromFilter);
  const filtersToConvertInGroups = filters.filter(requiresGrouping);
  const groupedOperators = getGroupedOperatorsFromObjSeg(filtersToConvertInGroups, getOperatorFromFilter, baseObjectTypeId);
  const groups = filterBranches.map(branch => fromObjectSegWithCustomObjects(branch, getField, parsedObjectTypeId, isUngated));
  const branchOperator = filterBranchOperator === 'AND' ? And : Or;
  return branchOperator.of(...operators, ...groupedOperators, ...groups).merge({
    filterFamily: parsedObjectTypeId,
    includeObjectsWithNoAssociatedObjects: getIncludeObjectsWithNoAssociatedObjects(filterBranch),
    associationTypeId: !isContactToProductObjectSegFilterBranch && !isContactToLineItemObjectSegFilterBranch ? filterBranch.associationTypeId : undefined,
    associationCategory: !isContactToProductObjectSegFilterBranch && !isContactToLineItemObjectSegFilterBranch ? filterBranch.associationCategory : undefined
  });
};
const fromObjectSegLegacy = (filterBranch, getField, baseFilterFamily, isUngated, options) => {
  const {
    filterBranches,
    filterBranchOperator,
    filters,
    objectType: objectSegType = baseFilterFamily
  } = filterBranch;

  // HACK: useDSFilterFamilies allows ObjectSeg to work in DSFilterEditor, this
  // can be removed once all ObjectSeg users are on DSFilterEditor see: https://git.hubteam.com/HubSpot/customer-data-filters/pull/406
  const useDSFilterFamilies = options.useDSFilterFamilies === true;
  const filterFamily = useDSFilterFamilies ? ObjectSegTypeToDSAssetFamily.get(objectSegType) || objectSegType : objectSegType;
  const getOperatorFromFilter = filter => fromObjectSegFilterStrict(filter, getField, filterFamily, isUngated);

  // @ts-expect-error transmute works with native data structures
  const filtersToConvert = filterNot(requiresGrouping, filters);
  const operators = filtersToConvert.map(getOperatorFromFilter);
  const filtersToConvertInGroups = filters.filter(requiresGrouping);
  const groupedOperators = getGroupedOperatorsFromObjSeg(filtersToConvertInGroups, getOperatorFromFilter, filterFamily);
  const groups = filterBranches.map(branch => fromObjectSegLegacy(branch, getField, filterFamily, isUngated, options));
  const branchOperator = filterBranchOperator === 'AND' ? And : Or;
  return branchOperator.of(...operators, ...groupedOperators, ...groups).set('filterFamily', filterFamily);
};
export const fromObjectSeg_XO = (filterBranch, baseFilterFamily, getField, isUngated, options = {}) => {
  invariant(isILSFilterBranch(filterBranch), `Expected ${filterBranch} to be a filter branch`);
  invariant(typeof baseFilterFamily === 'string', `Expected ${baseFilterFamily} to be a string`);
  invariant(typeof getField === 'function', `Expected ${getField} to be a function`);
  const validIsUngated = resolveIsUngated(isUngated);
  if (filterBranch.filterBranchOperator === RESTRICTED_FILTER_VALUE) {
    return Restricted();
  }
  const enableCustomObjectSupport = options.enableCustomObjectSupport === true;
  return enableCustomObjectSupport ? fromObjectSegWithCustomObjects(filterBranch, getField, baseFilterFamily, validIsUngated) : fromObjectSegLegacy(filterBranch, getField, baseFilterFamily, validIsUngated, options);
};